import { Petrus, Log } from '../dependencies';

import authenticate from '../services/sagas/authenticate';
import refreshTokens from '../services/sagas/refreshTokens';
import getAuthUser from '../services/sagas/getAuthUser';

// docs: https://github.com/AckeeCZ/petrus/blob/master/docs/api.md#configure
const { saga, reducer } = Petrus.configure({
    handlers: {
        authenticate,
        refreshTokens,
        getAuthUser,
    },
    logger: Log,
    tokens: {
        applyAccessTokenExternally: false,
    },
});

export { saga, reducer };
